module.exports = __webpack_public_path__ + "logo-minanny.png?0118bad9df554763ed0520b87830ed8c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/customer_logos/logo-minanny.png
// module id = 115
// module chunks = 0